import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Modal, ModalBody, ModalFooter, ModalHeader, Label, Input } from 'reactstrap'
import { createSelector } from 'reselect';
import { toggleNameYourTemplateModal } from '../../../../../../slices/modals/reducer';
import { setCampaignLoader, setTemplateName } from '../../../../../../slices/campaigns/reducer';
import { createTemplate } from '../../../../../../slices/campaigns/thunk';

function NameYourTemplate({setIsSubmit}) {
  const dispatch = useDispatch();
  const selectModalState = createSelector(state => state.Modal, state => state.nameYourTemplateModal);
  const modalState = useSelector(selectModalState);

  const selectTemplateName = createSelector(state => state.Campaign, state => state.templateName);
  const templateName = useSelector(selectTemplateName);
  
  function toggleModal() {
    dispatch(toggleNameYourTemplateModal());
  }

  function handleChange(e) {
    dispatch(setTemplateName(e.target.value));
  }

  async function handleSubmit() {
    toggleModal();
    dispatch(setCampaignLoader(true));
    await dispatch(createTemplate());  
    setIsSubmit(false);
    dispatch(setCampaignLoader(false));
  }

  return (
    <Modal isOpen={modalState} toggle={toggleModal} centered size='sm'>
      <ModalHeader className='p-3' toggle={toggleModal}>
        <b>Name your template</b>
      </ModalHeader>
      <ModalBody>
        <Label htmlFor='name'>Name</Label>
        <Input type='text' id='name' name='id' onChange={handleChange} value={templateName} />
      </ModalBody>
      <ModalFooter>
        <button className='btn btn-light' onClick={toggleModal}>Close</button>
        {templateName !== '' ? 
          <button className='btn btn-success' onClick={handleSubmit}>Create Template</button>
        : null}
      </ModalFooter>
    </Modal>
  )
}

export default NameYourTemplate
